import { useRef, useState } from "react"

//Assessments components
import QuestionOrder from "./QuestionOrder"

//dnd-kit
import { useDroppable } from "@dnd-kit/core"
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable"

//PrimeReact
import { Button } from "primereact/button"
import { OverlayPanel } from "primereact/overlaypanel"

//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormBuilder.module.css"
import managementFormStyles from "../../../../../styles/assessments/ManagementForm.module.css"

export default function FormBuilderForm({
  questionOrders,
  selectedOrderId,
  selectedQuestionId,
  editOrderId,
  editQuestionId,
  previewMode,
  onDeleteQuestion,
  onEditQuestion,
  onDeleteQuestionOrder,
  onEditQuestionOrder,
  disabled,
}) {
  const submitOverlayPanelRef = useRef(null)

  const [questionValues, setQuestionValues] = useState([])

  const { setNodeRef } = useDroppable({
    id: "FormBuilderFormBottom",
  })

  return (
    <>
      <div ref={setNodeRef} className={myStyles.formBuilderForm}>
        <SortableContext
          items={questionOrders.map((questionOrder) => questionOrder.id)}
          strategy={verticalListSortingStrategy}
          disabled={disabled}
        >
          {questionOrders.map((questionOrder) => (
            <QuestionOrder
              previewMode={previewMode}
              disabled={disabled}
              questionOrder={questionOrder}
              selectedQuestionId={selectedQuestionId || editQuestionId}
              key={questionOrder.id}
              answers={questionValues}
              onSetAnswer={(answer, question) => {
                const useQuestion = question ? question : questionOrder.question

                const answerIndex = questionValues.findIndex(
                  (value) => value.questionId === useQuestion?.id
                )

                if (answerIndex >= 0) {
                  setQuestionValues(
                    questionValues.map((entry) => {
                      if (entry.questionId === useQuestion?.id) {
                        return { ...entry, value: answer }
                      } else {
                        return entry
                      }
                    })
                  )
                } else {
                  setQuestionValues([
                    ...questionValues,
                    {
                      questionId: useQuestion?.id,
                      questionType: useQuestion?.type,
                      value: answer,
                    },
                  ])
                }
              }}
              isSelected={
                selectedOrderId === questionOrder.id ||
                editOrderId === questionOrder.id
              }
              onDeleteOrder={() => {
                onDeleteQuestionOrder(questionOrder.id)
              }}
              onEditOrder={() => {
                onEditQuestionOrder(questionOrder.id)
              }}
              onDeleteQuestion={(questionId) => {
                onDeleteQuestion(questionOrder.id, questionId)
              }}
              onEditQuestion={(questionId) => {
                onEditQuestion(questionOrder.id, questionId)
              }}
            />
          ))}
          {questionOrders.length > 0 ? (
            <div className={myStyles.formSubmitButtonContainer}>
              <Button
                type="button"
                label="Submit"
                onClick={(e) => {
                  submitOverlayPanelRef.current.toggle(e)
                }}
                className={managementFormStyles.button}
              />
              <OverlayPanel ref={submitOverlayPanelRef}>
                <p>This button is for illustration purposes only</p>
                <p>will be activated when completing a real assessment</p>
              </OverlayPanel>
            </div>
          ) : null}
        </SortableContext>
      </div>
    </>
  )
}
